import { Contact } from "@components/Contact";
import { TeamMembers } from "@components/TeamMembers";
import { PropertyListingTiles } from "@components/PropertyListingTiles";
import { SectionHeader } from "@components/SectionHeader";
import { useListingAgentsQuery } from "@gql";

const Home = () => {
  const { loading, data } = useListingAgentsQuery();

  const renderPropertyListingTiles = () => {
    if (loading) return null;
    const listingAgentIds = data?.listingAgents?.map(({ id }) => id);
    if (!listingAgentIds?.length) return null;

    return <PropertyListingTiles listingAgentIds={listingAgentIds} />;
  };

  return (
    <div id="static-pages-index">
      <div id="hero-container">
        <h1 className="text-center red">EXSELLence Team Realty Inc Brokerage</h1>
        <h3 className="text-center red">Helping you find your place to call home</h3>
        <div id="hero-image">
          <img src="/home.jpg" alt="what could be your home" />
        </div>
      </div>

      <div id="team-container" className="container">
        <SectionHeader text="Our Team" />
        <TeamMembers />
      </div>

      <div id="listings-container" className="container">
        <SectionHeader text="Our Listings" />
        {renderPropertyListingTiles()}
      </div>

      <div id="contact-container" className="container">
        <div className="row">
          <div className="small-12 columns">
            <Contact />
          </div>
        </div>
      </div>
    </div>
  );
};

export { Home };
